module.exports = __webpack_public_path__ + "static/media/right_blocks.c3189ead.svg";